"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostgresErrorMessage = void 0;
var PostgresErrorMessage;
(function (PostgresErrorMessage) {
    // https://github.com/postgres/postgres/blob/master/src/backend/access/nbtree/nbtinsert.c
    PostgresErrorMessage["DuplicateKey"] = "duplicate key value violates unique constraint";
    PostgresErrorMessage["InvalidUuid"] = "invalid input syntax for type uuid";
})(PostgresErrorMessage || (exports.PostgresErrorMessage = PostgresErrorMessage = {}));
